import NavBar from "../Navbar/Navbar";
import SideBar from "../Sidebar/SideBar";
import PropTypes from "prop-types";
import "./School-District.css";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Tooltip from "@mui/material/Tooltip";
import { TableSortLabel } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Dialog from "@mui/material/Dialog";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import TableRow from "@material-ui/core/TableRow";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import { Delete, Edit, PermIdentity } from "@material-ui/icons";
import { Link } from "react-router-dom";
import {
  addSchoolDestrict,
  createSchoolDestrictAdmin,
  deleteSchoolDistrictsAdmin,
  getAllSchoolDistricts,
  getSchoolDestrictAdmin,
  getSchoolDistrictsById,
  editSchoolDistrictsById,
  deleteSchoolDistrictsById,
  editSchoolDistrictsAdmin,
  districtAdminArray,
  createDistrictAdminManually,
  getUsersAdmin,
  addSchoolDistrictSchema,
} from "./api";
import getCookie, { setAdminCookie, userState } from "../../Atom";
import { useRecoilState, useRecoilValue } from "recoil";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { CircularProgress, Paper } from "@material-ui/core";
import CustomModal from "../Modal/CusModal";
import ManageSchoolDevice from "../ManageSchoolDistrictDevice/ManageSchoolDistrictDevice";
import { blue } from "@material-ui/core/colors";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const headCells = [
  {
    id: "_id",
    numeric: false,
    disablePadding: true,
    label: "Id",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "District",
  },
  {
    id: "fName",
    numeric: false,
    disablePadding: true,
    label: "Creator",
  },
  {
    id: "schools",
    numeric: false,
    disablePadding: true,
    label: "Schools",
  },
  {
    id: "manage",
    numeric: true,
    disablePadding: true,
    label: "Manage",
  },
];
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={"left"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.id !== "schools" ? (
              <TableSortLabel
                className="sort-header"
                sx={{ display: "flex", justifyContent: "left !important" }}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "desc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function SchoolDistrict() {
  const history = useHistory();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const [schoolDistrictList, setSchoolDistrictList] = useState([]);
  const [myUser, setmyUser] = useState(userState);
  const [adminFound, setadminFound] = useState(false);
  const [adminDetails, setadminDetails] = useState([]);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [activeId, setactiveId] = useState("");
  const [destrictId, setdestrictId] = useState("");
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [editMode, seteditMode] = useState(false);
  const [deleteMode, setdeleteMode] = useState(false);
  const [cirloading, setcirLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [color, setColor] = useState("red");
  const [showManageDevice, setShowManageDevice] = useState(false);
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [noOfPages, setNoOfPages] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(25);
  const [paged, setPaged] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageLimit);
  const handleShow = () => setShow(true);
  // const {token} = useRecoilValue(userState)
  const [adminlistShow, setAdminlistShow] = useState(false);
  const [category, setCategory] = useState("");
  const [adminId, setAdminId] = useState("");
  const [showAdmin, setShowAdmin] = useState(false);
  const [particularAdminDetails, setParticularAdminDetails] = useState({});
  const [individualSchool, setIndividualSchool] = useState("");
  const [adminMobile, setAdminMobile] = useState("");
  const [serverMsg, setServerMsg] = useState("");
  const [showCreateAdmin, setCreateNewAdmin] = useState(false);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("createdAt");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  // SnackBar Message
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [adminDeletePrompt, setAdminDeletePrompt] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataNewAdmin, setDataNewAdmin] = useState({
    fName: "",
    lName: "",
    email: "",
    password: "",
    mobile: "",
  });
  const [adminTouched, setAdminTouched] = useState({
    fName: false,
    lName: false,
    email: false,
    password: false,
    mobile: false,
  });
  const emailRegex = /^[a-zA-Z0-9._]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;

  const handleChange = (event) => {
    setCategory(event.target.value);
  };

  const logoutHandler = async () => {
    setTimeout(() => {
      // setmyUser({
      //   fName: null,
      //   userId: null,
      //   token: null,
      //   lName: null,
      // })
      setAdminCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      window.location.assign(
        `${window.location.protocol}//${hostname}/super-admin`
      );
    });
  };

  const getUsers = async () => {
    let res = await getUsersAdmin(myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
    }
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = schoolDistrictList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    let urlPage = parseInt(params.get("page")) || 0;
    let urlLimit = parseInt(params.get("limit")) || pageLimit;
    history.replace({
      pathname: "/school-Districts",
      search:
        "?page=" +
        urlPage +
        "&limit=" +
        urlLimit +
        "&orderBy=" +
        property +
        "&order=" +
        orderTemp,
    });
    setPaged(urlPage);
    setPageLimit(urlLimit);
    getSchoolDistricts(urlPage, urlLimit, property, orderTemp);
    setOrder(orderTemp);
    setOrderBy(property);
  };
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleClose = () => {
    setShow(false);
    setAdminlistShow(false);
    setadminDetails([]);
    setadminFound(false);
    setAdminId("");
    setShowAdmin(false);
    setAdminMobile("");
    setEmail("");
    setMessage("");
    setAdminDeletePrompt(false);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const submitHandler = async (e) => {
    e.preventDefault();
    let res;
    setLoading(true);
    if (!editMode && !deleteMode) {
      res = await addSchoolDestrict(
        { name: name.trim(), category: category.trim() },
        myUser.token
      );
    } else if (editMode) {
      res = await editSchoolDistrictsById(
        destrictId,
        { name: name.trim() },
        myUser.token
      );
    } else {
      res = await deleteSchoolDistrictsById(destrictId, myUser.token);
    }
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);

        setColor("red");
        setLoading(false);
      }
    } else {
      feedBackMsg(true, "success", res?.res?.data?.msg);
      setLoading(false);
      setName("");
      setCategory("");
      let urlPage = parseInt(params.get("page")) || 0;
      let urlLimit = parseInt(params.get("limit")) || pageLimit;
      let urlOrderBy = params.get("orderBy") || "createdAt";
      let urlOrder = params.get("order") || "desc";
      history.replace({
        pathname: "/school-Districts",
        search:
          "?page=" +
          urlPage +
          "&limit=" +
          urlLimit +
          "&orderBy=" +
          urlOrderBy +
          "&order=" +
          urlOrder,
      });
      setPaged(urlPage);
      setPageLimit(urlLimit);
      setOrderBy(urlOrderBy);
      setOrder(urlOrder);
      getSchoolDistricts(urlPage, urlLimit, urlOrderBy, urlOrder);
      handleCloseAddModal();
    }
  };

  const addDistrictSchema = async () => {
    let res = await addSchoolDistrictSchema(myUser.token);
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  const setupAdmin = async () => {
    let res = await createDistrictAdminManually(
      activeId,
      dataNewAdmin,
      myUser.token
    );
    if (res?.error) {
      // alert('Failed to create admin')
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);

        setColor("red");
        setLoading(false);
      }
    } else {
      feedBackMsg(true, "success", res?.res?.data?.msg);
      // alert('Admin is created')
      setDataNewAdmin({
        fName: "",
        lName: "",
        email: "",
        password: "",
        mobile: "",
      });
    }
    setCreateNewAdmin(false);
  };

  const ManageModal = (id, schoolId) => {
    setdestrictId(id);
    setShowManageDevice(true);
    if (schoolId == undefined) setIndividualSchool("");
    else setIndividualSchool(schoolId);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
    seteditMode(false);
    setdeleteMode(false);
    setdestrictId("");
    setName("");
    setAdminId("");
    setShowAdmin(false);
    setCreateNewAdmin(false);
    setAdminTouched({
      fName: false,
      lName: false,
      email: false,
      password: false,
      mobile: false,
    });
  };

  const buttonDisabled = () => {
    if (
      dataNewAdmin.fName.trim() == "" ||
      dataNewAdmin.fName == null ||
      dataNewAdmin.lName.trim() == "" ||
      dataNewAdmin == null ||
      dataNewAdmin.email.trim() == "" ||
      dataNewAdmin.email == null ||
      !emailRegex.test(dataNewAdmin.email) ||
      dataNewAdmin.password.trim() == "" ||
      dataNewAdmin.password == null ||
      dataNewAdmin.mobile.trim() == "" ||
      dataNewAdmin.mobile == null
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleShowAddModal = () => {
    setShowAddModal(true);
    setShowManageDevice(false);
  };

  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["KT_app"];
      setmyUser(user);
      let urlPage = parseInt(params.get("page")) || 0;
      let urlLimit = parseInt(params.get("limit")) || 0;
      let urlOrderBy = params.get("orderBy") || "createdAt";
      let urlOrder = params.get("order") || "desc";
      if (parseInt(params.get("page")) || parseInt(params.get("limit"))) {
        history.replace({
          pathname: "/school-Districts",
          search:
            "?page=" +
            urlPage +
            "&limit=" +
            urlLimit +
            "&orderBy=" +
            urlOrderBy +
            "&order=" +
            urlOrder,
        });
        setPaged(urlPage);
        setPageLimit(urlLimit);
        setOrderBy(urlOrderBy);
        setOrder(urlOrder);
        getSchoolDistricts(urlPage, urlLimit, urlOrderBy, urlOrder, user);
      } else {
        setPaged(0);
        history.push({
          pathname: "/school-Districts",
          search: `?page=0&limit=25&orderBy=${orderBy}&order=${order}`,
        });
        getSchoolDistricts(0, pageLimit, orderBy, order, user);
      }
    }
    // getSchoolDistricts();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPaged(event.selected);
    let urlOrderBy = params.get("orderBy") || "createdAt";
    let urlOrder = params.get("order") || "desc";
    getSchoolDistricts(event.selected, pageLimit, urlOrderBy, urlOrder);
    history.replace({
      pathname: "/school-Districts",
      search:
        "?page=" +
        event.selected +
        "&limit=" +
        pageLimit +
        "&orderBy=" +
        urlOrderBy +
        "&order=" +
        urlOrder,
    });
  };

  const checkSchoolDestrictAdmin = async (id) => {
    let res = await getSchoolDestrictAdmin(id, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setadminFound(res.res.data.data.adminFound);
      if (res.res.data.data.adminFound) {
        setadminDetails(res.res.data.data.admin);
        setAdminlistShow(true);
        // setfirstname(res.res.data.data.admin.fName);
        // setlastname(res.res.data.data.admin.lName);
      }
    }
    handleShow();
  };

  const getDeviceDetails = async (activeId, type) => {
    if (type === "edit") seteditMode(true);
    else setdeleteMode(true);
    setdestrictId(activeId);
    setShowAddModal(true);
    const tempArr = [];
    const langTemp = params?.row?.languages;
    langTemp?.map((item) => {
      tempArr.push(item?.value);
    });
    setShowManageDevice(false);
    let res = await getSchoolDistrictsById(activeId, myUser.token);
    if (res.error) {
      // alert('Couldnt fetch Device Details. Try Again')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      const tempArr = [];
      const langTemp = params?.row?.languages;
      langTemp?.map((item) => {
        tempArr.push(item?.value);
      });
      setName(res.res.data.data.schoolDistrict.name);
    }
  };

  function schoolDistrictButtonDisabled() {
    // eslint-disable-next-line no-unused-expressions
    // eslint-disable-next-line eqeqeq
    if (category == "" || name == "") {
      return true;
    } else {
      return false;
    }
  }

  const getSchoolDistricts = async (
    pages,
    limits,
    property,
    order,
    user = myUser
  ) => {
    let res = await getAllSchoolDistricts(
      user?.token,
      pages,
      limits,
      property,
      order
    );
    if (res?.error) {
      if (res?.data?.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      setSchoolDistrictList(res?.res?.data?.data?.data);
      let divisor = parseInt(res?.res?.data?.data?.totalCount / limits);
      let remainder = parseInt(
        res?.res?.data?.data?.totalcount % limits == 0 ? 0 : 1
      );
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
    }
  };

  const sendMail = async () => {
    let data = {
      id: activeId,
      data: { email: email.trim(), message: message.trim() },
    };
    let res = await createSchoolDestrictAdmin(data, myUser.token);
    if (!res.error) {
      // alert('Mail Sent')

      feedBackMsg(true, "success", res.res.data.msg);
    } else {
      // alert('Email already exists')
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    }
    handleClose();
  };
  const handleShowManageDevice = () => {
    setShowManageDevice(false);
  };

  const convertAdminArray = async () => {
    let res = await districtAdminArray(myUser.token);
    if (!res.error) {
    }
  };

  const showInvite = () => {
    setadminFound(false);
  };

  const edit_delete_Admin = async (type) => {
    let res;
    let sameMobile = false;
    if (type == "edit") {
      if (particularAdminDetails.mobile == adminMobile.trim()) {
        sameMobile = true;
      }
      res = await editSchoolDistrictsAdmin(
        activeId,
        adminId,
        {
          fName: firstname.trim(),
          lName: lastname.trim(),
          mobile: adminMobile.trim(),
          sameMobile: sameMobile,
          email: email.trim(),
        },
        myUser.token
      );
    } else {
      res = await deleteSchoolDistrictsAdmin(activeId, adminId, myUser.token);
    }

    if (!res.error) {
      let urlOrderBy = params.get("orderBy") || "createdAt";
      let urlOrder = params.get("order") || "desc";
      history.replace({
        pathname: "/school-Districts",
        search:
          "?page=" +
          paged +
          "&limit=" +
          pageLimit +
          "&orderBy=" +
          urlOrderBy +
          "&order=" +
          urlOrder,
      });
      // setOrderBy(urlOrderBy);
      // setOrder(urlOrder);
      await getSchoolDistricts(paged, pageLimit, orderBy, order);
      feedBackMsg(true, "success", res?.res?.data?.msg);
      handleClose();
    } else {
      // alert((type=='edit')?'Failed to edit District Admin':'Failed to delete District Admin');
      // alert(res.data);
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
      // alert()
      handleClose();
    }
  };

  const showParticularAdmin = (admin) => {
    setParticularAdminDetails(admin);
    setfirstname(admin.fName);
    setAdminMobile(admin?.mobile);
    setlastname(admin.lName);
    setEmail(admin.email);
    setAdminId(admin._id);
    setAdminlistShow(false);
    setShowAdmin(true);
  };

  const handleClosed = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack(false);
  };
  const [openSnack, setOpenSnack] = useState(false);

  const action = (
    <>
      {/* <Button color="secondary" size="small" onClick={handleClose}>
        UNDO
      </Button> */}

      <Button fontSize="small" onClick={handleClose}>
        X
      </Button>
    </>
  );
  const handleChangeRowsPerPage = (event) => {
    setPageLimit(parseInt(event.target.value, 10));
    setPaged(0);
    getSchoolDistricts(0, parseInt(event.target.value, 10), orderBy, order);
    history.replace({
      pathname: "/school-Districts",
      search:
        "?page=0" +
        "&limit=" +
        parseInt(event.target.value, 10) +
        "&orderBy=" +
        orderBy +
        "&order=" +
        order,
    });
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - schoolDistrictList.length)
      : 0;
  return (
    <section id="hero-school">
      <Snackbar
        open={openSnack}
        autoHideDuration={6000}
        onClose={handleClosed}
        message="Note archived"
        action={action}
      />
      {showManageDevice ? (
        <ManageSchoolDevice
          destrictId={destrictId}
          token={myUser?.token}
          showManageDevice={handleShowManageDevice}
          districtGroup={individualSchool}
        />
      ) : null}

      {showAddModal ? (
        <Dialog handleClose={handleCloseAddModal} open={showAddModal} fullWidth>
          <section id="hero-Msd">
            {!editMode && !deleteMode ? (
              <>
                <DialogTitle>
                  <Grid container justify="space-between" alignItems="center">
                    <Typography variant="h6" style={{ fontWeight: "600" }}>
                      Add School District
                    </Typography>
                    <IconButton onClick={handleCloseAddModal}>
                      <CloseIcon
                        style={{ border: "2px solid black", fontSize: "30px" }}
                      />
                    </IconButton>
                  </Grid>
                </DialogTitle>
                <div className="col-md-9 text-left  col-9 m-auto">
                  <div className="form-group mt-4   p-20">
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      placeholder="School District Name"
                      onBlur={(e) => setName(e.target.value.trim())}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <br />

                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Category
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={category}
                        label="Category"
                        onChange={handleChange}
                        sx={{ height: "49px" }}
                      >
                        <MenuItem value={"individual"}>Individual</MenuItem>
                        <MenuItem value={"group"}>Group</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <br />
                  <br />
                  <div className="form-group">
                    {loading ? (
                      <CircularProgress />
                    ) : (
                      <button
                        type="submit"
                        className="cta-btn"
                        disabled={schoolDistrictButtonDisabled()}
                        onClick={submitHandler}
                      >
                        Add
                      </button>
                    )}
                  </div>
                </div>
              </>
            ) : editMode ? (
              <>
                {/* <div className="mt-3">
                    <h6>Edit School District</h6>
                  </div> */}
                <DialogTitle>
                  <Grid container justify="space-between" alignItems="center">
                    <Typography variant="h6" style={{ fontWeight: "600" }}>
                      Edit School District
                    </Typography>
                    <IconButton onClick={handleCloseAddModal}>
                      <CloseIcon
                        style={{ border: "2px solid black", fontSize: "30px" }}
                      />
                    </IconButton>
                  </Grid>
                </DialogTitle>
                <div className="col-md-9 text-left  col-9 m-auto">
                  <div className="form-group mt-4   p-20">
                    <input
                      type="text"
                      value={name}
                      className="form-control"
                      placeholder="School District Name"
                      onBlur={(e) => setName(e.target.value.trim())}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <br />
                  <br />
                  <div className="form-group">
                    {loading ? (
                      <CircularProgress />
                    ) : (
                      <button
                        type="submit"
                        className="cta-btn"
                        onClick={submitHandler}
                        disabled={name.trim().length < 1}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* <div className="mt-3">
                    <h6>Remove School District</h6>
                  </div> */}
                <DialogTitle>
                  <Grid container justify="space-between" alignItems="center">
                    <Typography variant="h6" style={{ fontWeight: "600" }}>
                      Delete School District
                    </Typography>
                    <IconButton onClick={handleCloseAddModal}>
                      <CloseIcon
                        style={{ border: "2px solid black", fontSize: "30px" }}
                      />
                    </IconButton>
                  </Grid>
                </DialogTitle>
                <div className="col-md-9 text-left  col-9 m-auto">
                  <div className="form-group mt-4   p-20">
                    <h5>Are you Sure to Delete this School District?</h5>
                    <br></br>
                    <input
                      type="text"
                      readOnly
                      value={name}
                      className="form-control"
                      placeholder="School District Name"
                    />
                  </div>
                  <br />
                  <br />
                  <div className="form-group">
                    {loading ? (
                      <CircularProgress />
                    ) : (
                      <button
                        type="submit"
                        className="cta-btn-red"
                        onClick={submitHandler}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
          </section>
        </Dialog>
      ) : null}

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {!adminFound
              ? "Invite Admin"
              : adminlistShow
              ? "Admin List"
              : showAdmin
              ? "Admin"
              : adminDeletePrompt
              ? "Delete Admin"
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!adminFound && adminlistShow ? (
            <Button
              variant="danger"
              onClick={() => {
                setadminFound(true);
              }}
            >
              Back
            </Button>
          ) : null}
          {showAdmin ? (
            <Button
              variant="danger"
              onClick={() => {
                setadminFound(true);
                setShowAdmin(false);
                setAdminlistShow(true);
              }}
            >
              Back
            </Button>
          ) : null}
          {adminDeletePrompt ? (
            <Button
              variant="danger"
              onClick={() => {
                setShowAdmin(true);
                setAdminDeletePrompt(false);
              }}
            >
              Back
            </Button>
          ) : null}
          {!adminFound ? (
            <>
              <div className="form-group mt-4   p-20">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Email"
                  onBlur={(e) => setEmail(e.target.value.trim())}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-group mt-4   p-20">
                <textarea
                  className="form-control"
                  placeholder="Message"
                  onBlur={(e) => setMessage(e.target.value.trim())}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </>
          ) : showAdmin ? (
            <div>
              <TableContainer className="container table bg-danger">
                <Table stickyHeader aria-label="sticky table bg-danger">
                  <TableHead>
                    <TableCell>userType</TableCell>
                    <TableCell className="">
                      {/* {adminDetails.userType} */}
                      Admin
                    </TableCell>
                  </TableHead>
                  <TableHead>
                    <TableCell>Name</TableCell>
                    <TableCell className="">
                      {particularAdminDetails.fName}{" "}
                      {particularAdminDetails.lName}
                    </TableCell>
                  </TableHead>
                  <TableHead>
                    <TableCell>Email</TableCell>
                    <TableCell className="">
                      {particularAdminDetails.email}
                    </TableCell>
                  </TableHead>
                  <TableHead>
                    <TableCell>Mobile</TableCell>
                    <TableCell className="">
                      {particularAdminDetails.mobile}
                    </TableCell>
                  </TableHead>
                  <TableBody></TableBody>
                </Table>
              </TableContainer>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="exampleInputEmail1">FirstName</label>
                    <input
                      type="text"
                      value={firstname}
                      class="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="Text"
                      onBlur={(e) => setfirstname(e.target.value.trim())}
                      placeholder="FirstName"
                      onChange={(e) => setfirstname(e.target.value)}
                    />
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label for="exampleInputPassword1">LastName</label>
                    <input
                      type="text"
                      value={lastname}
                      class="form-control"
                      id="exampleInputPassword1"
                      onBlur={(e) => setlastname(e.target.value.trim())}
                      placeholder="LastName"
                      onChange={(e) => setlastname(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div class="col">
                  <div class="form-group">
                    <label for="exampleInputPassword1">Email</label>
                    <input
                      type="text"
                      value={email}
                      class="form-control"
                      id="exampleInputPassword1"
                      onBlur={(e) => setEmail(e.target.value.trim())}
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label for="exampleInputEmail1">Mobile</label>
                    <input
                      type="text"
                      value={adminMobile}
                      className="form-control"
                      id="exampleInputEmail1"
                      maxLength="16"
                      onBlur={(e) => setAdminMobile(e.target.value.trim())}
                      aria-describedby="Text"
                      placeholder="Mobile"
                      onChange={(e) => setAdminMobile(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : adminlistShow ? (
            <div>
              <div>
                <Button variant="danger" onClick={showInvite}>
                  Invite
                </Button>
              </div>

              <TableContainer
                className="container table bg-danger"
                style={{ width: "100%" }}
              >
                <Table stickyHeader aria-label="sticky table bg-danger">
                  <TableHead>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Mobile</TableCell>
                  </TableHead>
                  {adminDetails.map((item, index) => {
                    return (
                      <TableHead
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          showParticularAdmin(item);
                        }}
                      >
                        <TableCell>
                          {item.fName} {item.lName}
                        </TableCell>
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{item.mobile}</TableCell>
                      </TableHead>
                    );
                  })}
                  <TableBody></TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : adminDeletePrompt ? (
            <>
              <div>
                <br />
                <h6>
                  Are you sure to delete {firstname} {lastname}?
                </h6>
              </div>
            </>
          ) : null}
        </Modal.Body>
        <Modal.Footer style={{ width: "100%" }}>
          {!adminFound ? (
            <Button
              variant="primary"
              onClick={sendMail}
              disabled={email.trim().length < 1 || message.trim().length < 1}
            >
              Send Request
            </Button>
          ) : showAdmin ? (
            <>
              <div className="row" style={{ width: "100%" }}>
                <button
                  className="cta-btn col"
                  onClick={() => {
                    edit_delete_Admin("edit");
                  }}
                >
                  <Tooltip title="Edit" placement="top">
                    <Edit />
                  </Tooltip>
                </button>
                &nbsp;
                <button
                  className="bg-danger cta-btn col"
                  onClick={() => {
                    setShowAdmin(false);
                    setAdminDeletePrompt(true);
                  }}
                >
                  <Tooltip title="Delete" placement="top">
                    <Delete />
                  </Tooltip>
                </button>
              </div>
            </>
          ) : adminDeletePrompt ? (
            <>
              <div className="row" style={{ width: "100%" }}>
                <button
                  className="bg-danger cta-btn col"
                  onClick={() => {
                    edit_delete_Admin("delete");
                  }}
                >
                  <Tooltip title="Delete" placement="top">
                    <Delete />
                  </Tooltip>
                </button>
              </div>
            </>
          ) : null}
        </Modal.Footer>
      </Modal>

      <div>
        <NavBar />

        <div className="mt-5">
          <h2>
            All School District
            <Link onClick={handleShowAddModal}>
              <button className="btn btn-add float-right">
                <i className="fas fa-plus-circle"></i> {"  "}
                <span>New School District</span>
              </button>
            </Link>
          </h2>
        </div>
        <br />

        <div className="d-flex justify-content-end align-items-end">
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={noOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handleChangePage}
            containerClassName="pagination"
            activeClassName="activePage active"
            forcePage={currPage}
          />
        </div>
        {/* TABLE DONTAINER */}
        <div style={{ width: "100%" }} className="scrollLimits">
          <Paper sx={{ width: "100%", mb: 2 }}>
            <EnhancedTableToolbar numSelected={selected.length} />
            <TableContainer sx={{overflow: "auto" }}>
              <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size={"small"}
                stickyHeader
                className="table"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  // onSelectAllClick={handleSelectAllClick}
                  onRequestSort={onSetOrder}
                  rowCount={schoolDistrictList.length}
                />
                <TableBody>
                  {schoolDistrictList?.map((data, index) => (
                    <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                      <TableCell align="right">{data._id}</TableCell>
                      <TableCell align="right">
                        {data.schoolId == undefined ? (
                          <Link
                            className="sec-link"
                            to={"/district/" + data._id}
                          >
                            {data.name}
                          </Link>
                        ) : (
                          <Link
                            className="sec-link"
                            to={
                              "/district/" +
                              data._id +
                              "/school/" +
                              data.schoolId
                            }
                          >
                            {data.name}
                          </Link>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        {data.fName ? `${data?.fName} ${data?.lName}` : "-"}{" "}
                      </TableCell>
                      <TableCell align="right" className="sec-link">
                        {data?.schools
                          ?.map((school) => school?.name)
                          .reduce((acc, name, index, array) => {
                            // Check if it's the last item
                            const isLastItem = index === array.length - 1;
                            const isEndOfRow = index % 2 === 1;

                            if (isEndOfRow || isLastItem) {
                              return [
                                ...acc,
                                name + (!isLastItem ? ", " : ""),
                                <br key={index} />,
                              ]; // Add a comma after the second name unless it's the last one
                            }
                            return [...acc, name + ", "]; // Add comma after first name in the pair
                          }, [])}
                      </TableCell>

                      <TableCell align="right">
                        {" "}
                        <Tooltip title="Create Admin" placement="top">
                          <Link
                            onClick={() => {
                              setactiveId(data._id);
                              // checkSchoolDestrictAdmin(item._id);
                              setCreateNewAdmin(true);
                            }}
                          >
                            <i className="fas fa-user-plus icon-size-30"></i>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Admin" placement="top">
                          <Link
                            onClick={() => {
                              setactiveId(data._id);
                              checkSchoolDestrictAdmin(data._id);
                            }}
                          >
                            <svg
                              width="25"
                              height="25"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M25 26.25V23.75C25 22.4239 24.4732 21.1521 23.5355 20.2145C22.5979 19.2768 21.3261 18.75 20 18.75H10C8.67392 18.75 7.40215 19.2768 6.46447 20.2145C5.52678 21.1521 5 22.4239 5 23.75V26.25"
                                stroke="#495057"
                                strokeWidth="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M15 13.75C17.7614 13.75 20 11.5114 20 8.75C20 5.98858 17.7614 3.75 15 3.75C12.2386 3.75 10 5.98858 10 8.75C10 11.5114 12.2386 13.75 15 13.75Z"
                                stroke="#495057"
                                strokeWidth="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </Link>
                        </Tooltip>
                        {"  "}
                        <Tooltip title="Device" placement="top">
                          <Link
                            onClick={() => ManageModal(data._id, data.schoolId)}
                          >
                            <svg
                              width="25"
                              height="25"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21.0001 3.78098C21.0001 2.9106 20.7519 2.22182 20.2628 1.73416C18.2989 -0.22235 13.1357 1.85807 8.5061 6.47203C8.33788 6.63971 8.18413 6.81846 8.03629 7.00165C7.98776 6.98159 7.93191 6.96365 7.86769 6.94871C6.53437 6.63712 2.25517 7.36406 1.00944 12.3409C0.977382 12.4685 1.02866 12.6021 1.1376 12.6757C1.19041 12.7117 1.25145 12.7294 1.31247 12.7294C1.37685 12.7294 1.44126 12.7096 1.49588 12.6699C3.1867 11.4434 4.54315 10.95 5.72724 11.1316C5.64553 11.2798 5.56259 11.4243 5.47693 11.5624C5.40031 11.686 5.41893 11.8459 5.52178 11.9484L6.01212 12.4372L5.09424 13.3517C5.03534 13.4102 5.00237 13.4899 5.00237 13.5729C5.00237 13.6559 5.03534 13.7356 5.09424 13.7942L8.16585 16.8557C8.22688 16.9164 8.30651 16.9469 8.38648 16.9469C8.46644 16.9469 8.5461 16.9164 8.60713 16.8557L9.52623 15.9395L10.018 16.4297C10.0784 16.4898 10.1581 16.5209 10.2386 16.5209C10.295 16.5209 10.3518 16.5056 10.4025 16.4745C10.6316 16.3949 10.6657 16.3175 10.8036 16.2414C11.0071 17.4313 10.6143 18.7964 9.26814 20.6032C9.19064 20.6094 9.18789 20.7528 9.2611 20.8617C9.32001 20.9496 9.41798 21 9.52051 21C9.54555 21 9.57086 20.9969 9.59589 20.9908C14.5773 19.7521 15.3134 15.4879 15.0064 14.1579C14.9876 14.0767 14.963 14.0128 14.9364 13.9562C15.135 13.7992 15.3285 13.6353 15.5093 13.4551C18.8449 10.1308 21.0001 6.33318 21.0001 3.78098ZM6.018 10.6465C4.7988 10.2895 3.45908 10.6469 1.8682 11.6597C2.65067 9.48841 4.07586 8.46269 5.19402 7.9796C6.03234 7.61766 6.79528 7.51634 7.28356 7.51634C7.4145 7.51634 7.52525 7.52366 7.61285 7.53497L6.018 10.6465ZM8.38648 16.1931L5.75768 13.5729L6.45472 12.8786L8.72582 15.1418L9.08351 15.4983L8.38648 16.1931ZM13.9792 16.8041C13.4958 17.9238 12.4661 19.3505 10.2801 20.1327C11.2945 18.5485 11.6531 17.2143 11.3958 15.9984L14.4189 14.4078C14.4732 14.8186 14.4336 15.7513 13.9792 16.8041ZM11.8405 15.0203C11.2909 15.2849 10.7675 15.5364 10.2871 15.8153L6.1364 11.6786C6.36056 11.2948 6.56778 10.878 6.77766 10.4474L8.04666 8.05144C8.31226 7.64031 8.60651 7.25434 8.94738 6.91453C13.1827 2.69332 18.1616 0.623809 19.8215 2.17666C20.1889 2.54288 20.3751 3.08273 20.3751 3.78098C20.3751 6.13877 18.2422 9.84882 15.068 13.0126C14.1839 13.8936 12.9925 14.4664 11.8405 15.0203Z"
                                fill="#495057"
                                stroke="#495057"
                                strokeWidth="0.6"
                              />
                              <path
                                d="M14.3522 5.01655C13.9961 5.37086 13.7998 5.84236 13.7998 6.34405C13.7998 6.84608 13.9961 7.31759 14.3522 7.6719C14.7193 8.03718 15.2015 8.22 15.6837 8.22C16.1658 8.22 16.648 8.03718 17.0149 7.6719C17.371 7.31759 17.5669 6.84608 17.5669 6.34405C17.5669 5.84236 17.371 5.37086 17.0149 5.01655C16.2812 4.28595 15.0864 4.28595 14.3522 5.01655ZM16.5742 7.22877C16.0829 7.71765 15.2842 7.71765 14.7929 7.22877C14.5557 6.99255 14.4248 6.67852 14.4248 6.34405C14.4248 6.00989 14.5557 5.69586 14.7929 5.45964C15.0385 5.2152 15.3611 5.09314 15.6837 5.09314C16.0063 5.09314 16.3285 5.2152 16.5742 5.45964C16.8113 5.69586 16.9419 6.00989 16.9419 6.34405C16.9419 6.67852 16.8113 6.99255 16.5742 7.22877Z"
                                fill="#495057"
                                stroke="#495057"
                                strokeWidth="0.6"
                              />
                              <path
                                d="M6.14454 15.7335C6.02279 15.6111 5.82504 15.6111 5.70266 15.7329L2.57918 18.846C2.45708 18.9677 2.45649 19.1655 2.57855 19.2879C2.63958 19.3492 2.71955 19.3797 2.79981 19.3797C2.87946 19.3797 2.95943 19.3492 3.02046 19.2885L6.14394 16.1754C6.26601 16.0536 6.26663 15.8558 6.14454 15.7335Z"
                                fill="#495057"
                                stroke="#495057"
                                strokeWidth="0.6"
                              />
                              <path
                                d="M2.78994 17.2417C2.86959 17.2417 2.94953 17.2111 3.0106 17.1504L5.06748 15.1002C5.18954 14.9785 5.18985 14.7807 5.06807 14.6583C4.94632 14.536 4.74857 14.5356 4.62619 14.6577L2.56928 16.7079C2.44722 16.8297 2.4469 17.0274 2.56868 17.1498C2.62972 17.2111 2.70969 17.2417 2.78994 17.2417Z"
                                fill="#495057"
                                stroke="#495057"
                                strokeWidth="0.6"
                              />
                              <path
                                d="M6.78241 16.8074L4.72553 18.8576C4.60346 18.9793 4.60315 19.1771 4.72493 19.2995C4.78597 19.3608 4.8659 19.3913 4.94619 19.3913C5.02581 19.3913 5.10578 19.3608 5.16681 19.3001L7.22373 17.2499C7.34579 17.1281 7.34611 16.9304 7.22432 16.808C7.10257 16.6856 6.90479 16.6853 6.78241 16.8074Z"
                                fill="#495057"
                                stroke="#495057"
                                strokeWidth="0.6"
                              />
                            </svg>
                          </Link>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="Edit" placement="top">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              getDeviceDetails(data._id, "edit");
                            }}
                          >
                            <i className="fas fa-edit icon-size-30"></i>
                          </span>
                        </Tooltip>
                        &nbsp;
                        <Tooltip title="Delete" placement="top">
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              getDeviceDetails(data._id, "delete");
                            }}
                          >
                            <i className="fas fa-trash-alt icon-size-30"></i>
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}

                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: (dense ? 33 : 53) * emptyRows,
                      }}
                    >
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </div>

      <Dialog
        handleClose={handleCloseAddModal}
        open={showCreateAdmin}
        fullWidth
      >
        <DialogTitle>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h6" style={{ fontWeight: "600" }}>
              Add Admin
            </Typography>
            <IconButton onClick={handleCloseAddModal}>
              <CloseIcon
                style={{ border: "2px solid black", fontSize: "30px" }}
              />
            </IconButton>
          </Grid>
        </DialogTitle>
        <div className="col-md-9 text-left  col-9 m-auto">
          <div className="form-group mt-4   p-20">
            <input
              onBlur={(e) => {
                setAdminTouched({ ...adminTouched, fName: true });
                setDataNewAdmin({
                  ...dataNewAdmin,
                  fName: e.target.value.trim(),
                });
              }}
              type="text"
              className="form-control"
              placeholder="First Name"
              value={dataNewAdmin.fName}
              onChange={(e) => {
                setDataNewAdmin({ ...dataNewAdmin, fName: e.target.value });
              }}
            />
            {dataNewAdmin.fName.trim() == "" && adminTouched.fName ? (
              <span style={{ color: "red" }}>FirstName is required</span>
            ) : null}
          </div>
          <div className="form-group mt-4   p-20">
            <input
              onBlur={(e) => {
                setAdminTouched({ ...adminTouched, lName: true });
                setDataNewAdmin({
                  ...dataNewAdmin,
                  lName: e.target.value.trim(),
                });
              }}
              value={dataNewAdmin.lName}
              type="text"
              className="form-control"
              placeholder="Last Name"
              onChange={(e) => {
                setDataNewAdmin({ ...dataNewAdmin, lName: e.target.value });
              }}
            />
            {dataNewAdmin.lName.trim() == "" && adminTouched.lName ? (
              <span style={{ color: "red" }}>LastName is required</span>
            ) : null}
          </div>
          <div className="form-group mt-4   p-20">
            <input
              onBlur={(e) => {
                setAdminTouched({ ...adminTouched, email: true });
                setDataNewAdmin({
                  ...dataNewAdmin,
                  email: e.target.value.trim(),
                });
              }}
              value={dataNewAdmin.email}
              type="text"
              className="form-control"
              placeholder="Email"
              onChange={(e) => {
                setDataNewAdmin({ ...dataNewAdmin, email: e.target.value });
              }}
            />
            {dataNewAdmin.email.trim() == "" && adminTouched.email ? (
              <span style={{ color: "red" }}>Email is required</span>
            ) : !emailRegex.test(dataNewAdmin.email) &&
              dataNewAdmin.email.trim() != "" &&
              adminTouched.email ? (
              <span style={{ color: "red" }}>Email pattern is required</span>
            ) : null}
          </div>
          <div className="form-group mt-4   p-20">
            <input
              onBlur={(e) => {
                setAdminTouched({ ...adminTouched, password: true });
                setDataNewAdmin({
                  ...dataNewAdmin,
                  password: e.target.value.trim(),
                });
              }}
              type="text"
              value={dataNewAdmin.password}
              className="form-control"
              placeholder="Password"
              onChange={(e) => {
                setDataNewAdmin({ ...dataNewAdmin, password: e.target.value });
              }}
            />
            {dataNewAdmin.password.trim() == "" && adminTouched.password ? (
              <span style={{ color: "red" }}>Password is required</span>
            ) : null}
          </div>
          <div className="form-group mt-4   p-20">
            <input
              onBlur={(e) => {
                setAdminTouched({ ...adminTouched, mobile: true });
                setDataNewAdmin({
                  ...dataNewAdmin,
                  mobile: e.target.value.trim(),
                });
              }}
              type="text"
              value={dataNewAdmin.mobile}
              className="form-control"
              placeholder="Mobile"
              onChange={(e) => {
                setDataNewAdmin({ ...dataNewAdmin, mobile: e.target.value });
              }}
            />
            {dataNewAdmin.mobile.trim() == "" && adminTouched.mobile ? (
              <span style={{ color: "red" }}>Mobile is required</span>
            ) : null}
          </div>

          <div className="form-group p-20">
            <button
              onClick={setupAdmin}
              type="button"
              className="cta-btn"
              disabled={!buttonDisabled()}
            >
              {loading ? <CircularProgress /> : "Add"}
            </button>
          </div>
        </div>
      </Dialog>

      {/* Snack Bar Messages */}

      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </section>
  );
}
